import { ReactNode, useReducer } from 'react';
import TransactionContext from './transactionContext';
import transactionReducer from './transactionReducer';
import { TransactionStateType } from './transactionTypes';

type TransactionStateProps = {
    children: ReactNode;
};

const initialState: TransactionStateType = {
    pendingTransactions: [],
};

const TransactionState: React.FC<TransactionStateProps> = ({ children }) => {
    const [state, dispatch] = useReducer(transactionReducer, initialState);

    return (
        <TransactionContext.Provider value={{ ...state, dispatch }}>
            {children}
        </TransactionContext.Provider>
    );
};

export default TransactionState;
